import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './styles.module.scss';
import Money from '../../../../../app/common/money';
export var ServiceItemView = function (props) {
    var _a;
    return (_jsxs("button", { type: "button", className: classnames(styles['service-item'], (_a = {}, _a[styles.active] = props.isSelected, _a)), onClick: props.onClick, children: [_jsx("span", { className: "u-text-trim", children: props.service.name }), _jsxs("span", { className: "u-type--bold", children: ["\u00A0", _jsx(Money, { cents: props.service.cost }), "\u00A0/\u00A0", props.service.duration, "m"] })] }));
};
